import React, { useContext, useEffect, useState} from "react";
import { authenticatedContext, userDataContext } from "../App";
import { ButtonWIcon } from './Inputs'
import Table from "./Table";
import '../css/clients.css';
import { useNavigate } from "react-router-dom";
import { ExportContext } from './Layout'

const Clients = () => {

  const { authenticated, setAuthenticated } = useContext(authenticatedContext);
  const { userData, setUserData } = useContext(userDataContext);

  const [firstName, setFirstName] = useState("");
  const [firstNameSort, setFirstNameSort] = useState(0);
  const [lastName, setLastName] = useState("");
  const [lastNameSort, setLastNameSort] = useState(0);
  const [birthDateSort, setBirthDateSort] = useState(0);
  const [cardNumber, setCardNumber] = useState("");
  const [tagList, setTagList] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [reqUrl, setReqUrl] = useState("");
  const navigate = useNavigate();

  const exportFile = useContext(ExportContext);

  function exportClients() {
    exportFile("export/clients/", 'Clients_export.csv')
  }

  useEffect(() => {
    setReqUrl(`/clients/filter/${firstName || "null"}/${firstNameSort}/${lastName || "null"}/${lastNameSort}/${birthDateSort}/${cardNumber || "null"}/${tagList.join(",") || "null"}/${projectList.join(",") || "null"}`);
  }, [firstName, firstNameSort, lastName, lastNameSort, birthDateSort, cardNumber, tagList, projectList])
  return (
    <div className="clients">
      <div className="heading-controls">
        <h3>Vaši Klienti</h3>
        <div className="head-controls">
          <ButtonWIcon iconSrc={"/img/svg/export.svg"} onClick={exportClients} text={"Exportovat"}/>
          <ButtonWIcon text={"Vytvořit klienta"} iconSrc={"/img/svg/add.svg"} onClick={() => { navigate('/add_new_client/p1') }} />
        </div>
      </div>
      <Table
        reqUrl={reqUrl}
        headers={[
          {
            name: "Jméno",
            dataKey: "first_name",
            search: {
              value: firstName,
              setValue: setFirstName
            },
            sort: {
              value: firstNameSort,
              setValue: setFirstNameSort
            },
            type: "text",
          },
          {
            name: "Příjmení",
            dataKey: "last_name",
            search: {
              value: lastName,
              setValue: setLastName
            },
            sort: {
              value: lastNameSort,
              setValue: setLastNameSort
            },
            type: "text",
          },
          {
            name: "Datum narození",
            dataKey: "birth_date",
            search: false,
            sort: {
              value: birthDateSort,
              setValue: setBirthDateSort
            },
            type: "time_date",
          },
          {
            name: "Číslo karty",
            dataKey: "card_number",
            search: {
              value: cardNumber,
              setValue: setCardNumber
            },
            sort: false,
            type: "text",
          },
          {
            name: "Projekty",
            dataKey: "projects",
            search: {
              value: projectList,
              setValue: setProjectList
            },
            sort: false,
            category_options_data_key: "availible_projects",
            type: "category",
          },
          {
            name: "Štítky",
            dataKey: "tags",
            search: {
              value: tagList,
              setValue: setTagList
            },
            sort: false,
            category_options_data_key: "availible_tags",
            type: "category",
          },
        ]}
        actions={{
          displayButtons: true,
          edit: true,
          view: true,
          delete: true,
          requestBase: "/client/",
          recordIdKey: "client_id"
        }}

      />
    </div>
  );
};

export default Clients;



